// 按需全局引入 @组件
import Vue from 'vue'
import { Button, Cell, Tabbar, TabbarItem, NavBar, Checkbox, Field, Form, Image } from 'vant'
Vue.use(Button).use(Cell).use(Tabbar).use(TabbarItem).use(NavBar).use(Checkbox).use(Field).use(Form).use(Image)
